import axios from '@/axios';

const RESOURCE_NAME = '/dashboard';

export default {

    getAvailableCharts() {
        return axios.get(`${RESOURCE_NAME}/get-available-charts`)
    },

    getSettings() {
        return axios.get(`${RESOURCE_NAME}/get-settings`)
    },

    sendChartsRequest(type) {
        return axios.post(`${RESOURCE_NAME}/send-charts-request?type=${type}`)
    },

    getChartData(chartType, period, userType, trackers) {
        return axios.post(`${RESOURCE_NAME}/get-chart-data?chart_type=${chartType}`, {
            period: period,
            user_type: userType,
            trackers: trackers,
        })
    },

    getChartStartupsList(chartType, period, userType, trackers, code, currentPage, pageLength) {
        return axios.post(`${RESOURCE_NAME}/get-chart-startups-list?chart_type=${chartType}`, {
            period: period,
            user_type: userType,
            trackers: trackers,
            code: code,
            page: currentPage,
            length: pageLength
        })
    },

    getWidgetData(widgetType, period = "", userType = "", trackers = []) {
        return axios.post(`${RESOURCE_NAME}/get-widget-data?widget_type=${widgetType}`, {
            period: period,
            user_type: userType,
            trackers: trackers,
        })
    },
}
